import React from 'react';
import cn from 'classnames';

import Icon from '@/ui/Icon';

import styles from './style.scss';

type Props = {
    afterAuthRedirectUrl?: string;
    isProcessingAgreed: boolean;
    isAdvertisingAgreed: boolean;
    className?: string;
};

const AuthVkBtn = ({ afterAuthRedirectUrl, isProcessingAgreed, isAdvertisingAgreed, className }: Props) => {
    const isDisabled = !isProcessingAgreed;
    const classNames = cn(styles.authVkBtn, { [styles.authVkBtnDisabled]: isDisabled }, className);
    const content = (
        <>
            <Icon name="vk" size="extra-large" className={styles.authVkBtnIcon} />
            <span>Войти через VK</span>
        </>
    );

    if (isDisabled) {
        return (
            <button type="button" disabled className={classNames}>
                {content}
            </button>
        );
    }

    const params = new URLSearchParams({
        next: afterAuthRedirectUrl || '/ru/dashboard/my',
        is_processing_agreed: String(isProcessingAgreed),
        is_advertising_agreed: String(isAdvertisingAgreed),
    });

    return (
        <a href={`/api/v1/auth/sso/vk/init/?${params.toString()}`} className={classNames}>
            {content}
        </a>
    );
};

export default AuthVkBtn;
